import { useState, useEffect, useRef } from "react";

// react-images-viewer components
import Lightbox from "yet-another-react-lightbox";
import Zoom from "yet-another-react-lightbox/plugins/zoom";
import Download from "yet-another-react-lightbox/plugins/download";
import Thumbnails from "yet-another-react-lightbox/plugins/thumbnails";

// @mui material components
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";

// Soft UI Dashboard PRO React components
import SuiBox from "components/SuiBox";
import SuiButton from "components/SuiButton";

// Images
import ImageCardWrapper from "components/UpStyled/ImageCardWrapper";
import Prompt from "components/UpStyled/Prompt";

const StyleImages = ({ designFiles = [], techPacksFiles = [] }) => {
  const [currentImage, setCurrentImage] = useState({});
  const [imgsViewerVisible, setImgsViewerVisible] = useState(false);
  const [imgsViewerCurrent, setImgsViewerCurrent] = useState(0);
  const [pdfVisible, setPdfVisible] = useState(false);

  const domRef = useRef(null);

  const images = [...designFiles, ...techPacksFiles].filter(
    (f) => f?.type && (f.type.includes("image") || f.type == "application/pdf")
  );

  const imagesOnly = images.filter((x) => x.type.includes("image")); //remove pdf

  useEffect(() => {
    const file = images.find(
      (f) => f?.type && (f.type.includes("image") || f.type == "application/pdf")
    );
    if (file && file.url) {
      setCurrentImage(file);
    } else {
      setCurrentImage({});
    }
  }, []);

  const handleSetCurrentImage = (img) => {
    setCurrentImage(img);
    if (img.type.includes("image")) {
      let index = imagesOnly.findIndex((x) => x.url == img.url);
      setImgsViewerCurrent(index);
    }
  };

  const openImgsViewer = () => setImgsViewerVisible(true);
  const closeImgsViewer = () => setImgsViewerVisible(false);

  return (
    <SuiBox sx={{ height: "100%" }}>
      <Lightbox
        open={imgsViewerVisible}
        close={closeImgsViewer}
        slides={imagesOnly.map((x, index) => ({ src: x.url, id: index }))}
        plugins={[Zoom, Download, Thumbnails]}
        zoom={{ maxZoomPixelRatio: 3 }}
        index={imgsViewerCurrent}
      />

      <SuiBox
        display="flex"
        alignItems="flex-start"
        justifyContent="flex-start"
        sx={{ height: "100%" }}
      >
        <SuiBox sx={{ flexGrow: 0, px: 1 }}>
          <SuiBox
            display="flex"
            flexDirection="column"
            gap={1}
            sx={{
              overflowY: "auto",
              overflowX: "hidden",
              pr: 3,
              flexWrap: "nowrap",
              maxHeight: 600,
              height: "auto",
            }}
          >
            {images.map((img, index) => (
              <div
                id={index}
                alt={"small_image " + index}
                style={{
                  px: 0.5,
                  py: 0.5,
                  width: 80,
                  minWidth: 80,
                  minHeight: 80,
                  height: 80,
                  cursor: "pointer",
                  border: "1px solid #e3e3e3",
                }}
                onClick={() => handleSetCurrentImage(img)}
              >
                <ImageCardWrapper
                  data={img}
                  height={80}
                  width={80}
                  iconMode
                  sx={{
                    borderRadius: "none",
                    shadow: ({ boxShadows }) => boxShadows.md,
                    overflow: "hidden",
                  }}
                />
              </div>
            ))}
          </SuiBox>
        </SuiBox>
        <SuiBox pl={3} sx={{ width: "100%", overflow: "hidden" }}>
          <SuiBox
            sx={{
              overflow: "hidden",
              flexGrow: "1",
              backgroundColor: "#efefef",
              width: "100%",
            }}
            ref={domRef}
            onClick={
              currentImage?.type && currentImage?.type.includes("image")
                ? () => {
                    handleSetCurrentImage(currentImage);

                    openImgsViewer();
                  }
                : () => setPdfVisible(true)
            }
          >
            <ImageCardWrapper
              data={currentImage}
              height={600}
              resizeType="m_mfit"
              pdfPagination={true}
              parentRef={domRef}
              width="auto"
              sx={{
                cursor: "pointer",
                marginLeft: "50%",
                WebkitTransform: "translateX(-50%)",
              }}
            />
          </SuiBox>
        </SuiBox>
      </SuiBox>
      {pdfVisible ? (
        <Prompt
          option={{ maxWidth: "md" }}
          text={<ImageCardWrapper data={currentImage} pdfPagination={true} />}
          heading={currentImage.name}
          visible={pdfVisible}
          hideAction={true}
          handleOk={() => setPdfVisible(false)}
          handleClose={() => setPdfVisible(false)}
        />
      ) : null}
    </SuiBox>
  );
};

export default StyleImages;
